module.exports = "/assets/9eb6abfe4dce34cf27f943205c6832c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AS.png
// module id = 1206
// module chunks = 0